// Plain-English names for evidence and safeguard statuses (constitution §5.10), and their pill.
import type { SafeguardStatus } from '@cis/api-client';
import './evidence.css';

export const STATUS_LABELS: Readonly<Record<SafeguardStatus, string>> = {
  none: 'No evidence line',
  planned: 'Planned',
  implemented: 'Implemented',
  verified: 'Verified',
  gap_exc: 'Gap (exception)',
};

export function EvidenceStatusPill(props: { readonly status: SafeguardStatus }): React.JSX.Element {
  return (
    <span className={`pill evidence-pill--${props.status}`}>{STATUS_LABELS[props.status]}</span>
  );
}

/** The read-only marker on a frozen task or evidence page (Q26, spec J5 step 4). */
export function FrozenBadge(): React.JSX.Element {
  return <span className="pill evidence-pill--frozen">Frozen</span>;
}
